/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Results_Adjust_SearchInputs */

const en_no_results_adjust_search = /** @type {(inputs: No_Results_Adjust_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your search criteria or clearing some filters to see more results.`)
};

const de_no_results_adjust_search = /** @type {(inputs: No_Results_Adjust_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deine Suchkriterien an oder entferne einige Filter, um mehr Ergebnisse zu sehen.`)
};

/**
* | output |
* | --- |
* | "Try adjusting your search criteria or clearing some filters to see more results." |
*
* @param {No_Results_Adjust_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_results_adjust_search = /** @type {((inputs?: No_Results_Adjust_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Results_Adjust_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_results_adjust_search(inputs)
	return en_no_results_adjust_search(inputs)
});